import api from '../utils/api';
class DashboardApi {
  getAll = (operator) => {
    return new Promise(async (resolve, reject) => {
      try {
        let url;
        if (operator) {
          url = `/reports/dashboard?operator_id=${operator}`;
        } else {
          url = '/reports/dashboard';
        }
        const res = await api.get(url);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getRevenue = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get('/reports/revenue', { params: data });
        console.log('resresresres', res);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };
}
const dashboardApi = new DashboardApi();
export default dashboardApi;
